// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__T-8TW","list":"PatternAutocomplete_list__2cwzp"};